/**
 * Branding, in one place.
 *
 * Two distinct names are involved and they are not interchangeable:
 *   BRAND_NAME  the operator the portal belongs to — the large wordmark and
 *               the logo in the corner.
 *   APP_NAME    the product itself — the tab title, the low-bandwidth option
 *               and the footer.
 *
 * All of it comes from client/.env, so the repo carries no operator assets.
 */

/** Operator / company, e.g. "PETRONAS". */
export const BRAND_NAME = import.meta.env.VITE_BRAND_NAME ?? 'WELLXP';

/** Product name, e.g. "WellXP". */
export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'WellXP';

/** Path under public/ for the operator logo; empty falls back to a drawn mark. */
export const BRAND_LOGO = import.meta.env.VITE_BRAND_LOGO ?? '';

/** Path under public/ for the sign-in backdrop; empty falls back to drawn dots. */
export const BRAND_BACKDROP = import.meta.env.VITE_BRAND_BACKDROP ?? '';

export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '0.1.0';
